

export const themeBackgroundPrimaryColor = "#40434E"